import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchRoomsByStays } from '../../features/admin/roomSlice';
import { AppDispatch, RootState } from '../../store';
import RoomForm from './models/RoomForm';
import { Room } from '../../types';
import RoomList from './models/RoomList';

const Rooms = () => {
    const { placeId } = useParams<{ placeId: string }>();
    const { t } = useTranslation();
    const userId = Cookies.get('userId');
    const [showRoomStep, setShowRoomStep] = useState(false);
    const [selectedRoomToEdit, setSelectedRoomToEdit] = useState<Room | null>(null);
    const dispatch = useDispatch<AppDispatch>();
    const { Rooms } = useSelector((state: RootState) => state.roomSlice);
    useEffect(() => {
        if (placeId) {
            userId && dispatch(fetchRoomsByStays({ stayId: parseInt(placeId), userId }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [placeId, dispatch]);
    return (
        <div>
            <div>
                <div className=' bg-gradient-to-r from-blue-600 to-indigo-500 text-white rounded-xl shadow-md p-6 mb-6'>
                    <h2 className='text-white text-lg font-semibold'>{t("rooms")}</h2>
                </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-4">
                {Rooms && Rooms?.length > 0 ?
                    <RoomList
                        placeId={placeId}
                        rooms={Rooms}
                        setShow={setShowRoomStep}
                        setRoomToEdit={setSelectedRoomToEdit}
                    />
                    :
                    <div className=' w-full  flex-center flex-col py-3 gap-2 ' >
                        <div className=' w-full  flex-center flex-col py-3 gap-2 ' >
                            <p className='text-black font-bold'>{t("no-rooms-available")}</p>
                            <button onClick={() => setShowRoomStep(true)} className=' bg-primary py-1 px-2  text-white rounded-lg '>{t("add-room")}</button>
                        </div>
                    </div>
                }
            </div>
            {showRoomStep && (
                <div className="mt-10 space-y-8">
                    <RoomForm
                        placeId={placeId}
                        setShow={() => {
                            setShowRoomStep(false);
                            setSelectedRoomToEdit(null);
                        }}
                        existRoom={selectedRoomToEdit || undefined}
                    />
                </div>
            )}
        </div>

    )
}

export default Rooms